import { ValidateMessages } from '../../constants/ValidateConstants';
import ValidateField from '../../hooks/useValid';
import { ValidateName } from '../../constants/ValidateNameConstants';

export default function validation(values,allocatedToInq,assignedInqEngineer) {
  let errors = {};

  errors.customerName = ValidateField(values.customerId, ValidateName?.CUSTOMER_NAME,
    ValidateName?.CUSTOMER_NAME, [ValidateName?.REQUIRED]);

  errors.customerAddress = ValidateField(values.customerAddress, ValidateName?.CUSTOMER_ADDRESS,
    ValidateName?.CUSTOMER_ADDRESS, [ValidateName?.REQUIRED]);

  errors.contactPerson = ValidateField(values.contactPerson, ValidateName?.CONTACT_PERSON,
    ValidateName?.CONTACT_PERSON, [ValidateName?.REQUIRED]);

  errors.country = ValidateField(values.countryId, ValidateName?.COUNTRY,
    ValidateName?.COUNTRY, [ValidateName?.ISREQUIRED_NO]);

  errors.mobileNo = ValidateField(values.mobileNo, ValidateName?.PHONE_NUMBER,
    ValidateName?.PHONE_NUMBER, [ValidateName?.REQUIRED, ValidateName?.ISVALID_PHONE]);

  errors.allocatedName = ValidateField(allocatedToInq, ValidateName?.ALLOCATEDTO,
    ValidateName?.ALLOCATEDTO, [ValidateName?.REQUIRED]);

  errors.emailAddress = ValidateField(values.emailAddress, ValidateName?.EMAIL,
    ValidateName?.EMAIL, [ValidateName?.REQUIRED, ValidateName?.ISVALID_EMAIL]);

  errors.currency = ValidateField(values.currencyId, ValidateName?.CURRENCY,
    ValidateName?.CURRENCY, [ValidateName?.REQUIRED]);

  errors.projectName = ValidateField(values.projectId, ValidateName?.PROJECT,
    ValidateName?.PROJECT, [ValidateName?.ISREQUIRED_NO]);

  // errors.customerRef = ValidateField(values.customerRef, ValidateName?.ENQUIRY_REF,
  //   ValidateName?.ENQUIRY_REF, [ValidateName?.REQUIRED]);

  errors.assignedEngineer = ValidateField(assignedInqEngineer, ValidateName?.ASSIGNED_ENGINEER,
    ValidateName?.ASSIGNED_ENGINEER, [ValidateName?.ISREQUIRED_NO]);

  errors.distributorName = ValidateField(values.distributorId, ValidateName?.DISTRIBUTOR_NAME,
    ValidateName?.DISTRIBUTOR_NAME, [ValidateName?.ISREQUIRED_NO]);

  errors.inquiryType = ValidateField(values.inquiryType, ValidateName?.ENQUIRY_TYPE,
    ValidateName?.ENQUIRY_TYPE, [ValidateName?.REQUIRED]);

  if (values?.dueDate === '') errors['dueDate'] = ValidateMessages.SELECT_DUE_DATE

  let error = {}
  Object.keys(errors).map((key, index) => {
    if (errors[key] !== undefined)
    error[key] = errors[key]
  })


  return error;
}


